import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
export const SPONSORSINSIGHT_TOTAL_SPONLISTVIEW =
  "SPONSORSINSIGHT_TOTAL_SPONLISTVIEW";

const sponsorsinsightsponlistviewcount = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=listviewcnt`;

  return (dispatch) => {
    postRequest(
      url,
      {
        type: "listviewcnt",
        types: "entry",
        screen: "sponsors",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for ..
        dispatch({
          type: SPONSORSINSIGHT_TOTAL_SPONLISTVIEW,
          payload: { count: data.count },
        });
        callback({
          error: 0,
          data: "Analytics, Number of user who browsed through the sponsors list !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export { sponsorsinsightsponlistviewcount };
